import React, { Fragment, useEffect } from 'react';
import styled from 'styled-components';
import { NavLink, useLocation } from 'react-router-dom';
import { Typography, Popover, Box, Divider } from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const activeClassName = 'nav-item-active';
const StyledLink = styled(NavLink).attrs({ activeClassName })`
  text-decoration: none;
  color: #424244;

  & p {
    line-height: 2.2;
  }

  &.${activeClassName} {
    & p {
      color: #e3232a;
    }
  }
`;

const StyledLinkPopover = styled.div`
  text-decoration: none;
  color: #424244;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:not(:last-child) {
    margin-right: 2rem;
  }
`;

const StyledLinkNotPopover = styled(NavLink).attrs({ activeClassName })`
  /* margin-right: 2rem; */
  text-decoration: none;
  color: #424244;

  &:not(:last-child) {
    margin-right: 2rem;
  }

  &.${activeClassName} {
    & p {
      color: #e3232a;
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  popover: {
    '&.MuiPopover-root': {
      cursor: 'pointer',
      boxShadow:
        'inset 0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
      zIndex: '0 !important',
    },
    '& .MuiPaper-root': {
      minWidth: 200,
    },
  },
  customText: {
    [theme.breakpoints.up(2560)]: {
      fontSize: '26px',
    },
  },
}));

const Navigation: React.FC<any> = ({ isId, DataNav }) => {
  const classes = useStyles();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [activeState, setActiveState] = React.useState('');
  const [expandAnnouncementState, setExpandAnnouncementState] =
    React.useState(false);

  const handleClick = (event: any, val: string) => {
    setActiveState(val);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActiveState('');
  };

  useEffect(() => {
    handleClose();
  }, [location.pathname]);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  return (
    <>
      {DataNav.map((data: any) => {
        if (data.children) {
          return (
            <StyledLinkPopover
              onClick={(e) => handleClick(e, data.link)}
              key={data.title}
            >
              <Typography
                style={{
                  color:
                    data.title === activeState ||
                    `/${location.pathname.split('/')[1]}` === data.link
                      ? '#e3232a'
                      : '#424244',
                }}
                className={classes.customText}
              >
                {isId ? data.title : data.titleEn}
              </Typography>
            </StyledLinkPopover>
          );
        }
        return (
          <StyledLinkNotPopover
            to={data.link}
            exact={data.exact}
            key={data.title}
          >
            <Typography className={classes.customText}>
              {isId ? data.title : data.titleEn}
            </Typography>
          </StyledLinkNotPopover>
        );
      })}
      {activeState && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          className={classes.popover}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <Box style={{ padding: '16px', paddingTop: 8 }}>
            {DataNav.find((r: any) => r.link === activeState)['children']?.map(
              (row: any, i: number) => {
                return (
                  <Fragment key={row.title}>
                    <div>
                      {row.children ? (
                        <>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 2,
                            }}
                            onClick={() =>
                              setExpandAnnouncementState(
                                !expandAnnouncementState
                              )
                            }
                          >
                            <Typography style={{ lineHeight: 2.2 }}>
                              {isId ? row.title : row.titleEn}
                            </Typography>
                            {!expandAnnouncementState ? (
                              <ExpandMore />
                            ) : (
                              <ExpandLess />
                            )}
                          </div>
                        </>
                      ) : (
                        <StyledLink to={row.link} exact={row.exact}>
                          <Typography>
                            {isId ? row.title : row.titleEn}
                          </Typography>
                        </StyledLink>
                      )}
                    </div>
                    <div style={{ marginLeft: 16 }}>
                      {expandAnnouncementState &&
                        row.children?.map((row2: any, i2: number) => (
                          <StyledLink to={row2.link} exact={row2.exact}>
                            <Typography>
                              {isId ? row2.title : row2.titleEn}
                            </Typography>
                            {row.children.length - 1 !== i2 && <Divider />}
                          </StyledLink>
                        ))}
                    </div>
                    {DataNav.filter((r: any) => r.title === activeState)
                      .children?.length -
                      1 !==
                      i && <Divider />}
                  </Fragment>
                );
              }
            )}
          </Box>
        </Popover>
      )}
    </>
  );
};

export default Navigation;
